import UnsupportedChunk from './UnsupportedChunk';

export default UnsupportedChunk;
